<template>
  <div>
    <el-menu class="navbar">
      <!-- <hamburger
        id="hamburger-container"
        @toggleClick="toggleSideBar"
        :is-active="sidebar.opened"
        class="hamburger-container"
      /> -->
      <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
      <div class="navbar-box">
        <img src="@/assets/image/list.png" alt="" />
      </div>

      <div class="right-menu">
        <el-popover placement="top" width="375" v-model="visible">
          <!-- <p>这是一段内容这是一段内容确定删除吗？</p> -->
          <div class="msg" v-loading="loading">
            <template v-if="notifyLogList.length > 0">
              <div
                class="msg-box"
                v-for="(item, index) in notifyLogList"
                :key="index"
              >
                <img src="@/assets/image/notifyLog.png" alt="" />
                <div class="msg-box-content">
                  <!-- <div>{{JSON.parse(item.snap).content}}</div> -->
                  <div>{{ item.content }}</div>
                  <div>{{ item.created_at }}</div>
                </div>
              </div>
              <!-- <div class="more" @click="goMore"><span>查看更多</span><p>></p></div> -->
            </template>
            <!-- <el-empty v-else :image-size="200" description="暂无通知"></el-empty> -->
          </div>
          <div slot="reference" class="right-menu-badge">
            <el-badge
              :value="
                getUserInfo.no_read_num == 0 ? '' : getUserInfo.no_read_num
              "
              class="item"
            >
              <img class="msgs" src="@/assets/image/msg.png" alt="" />
            </el-badge>
          </div>
        </el-popover>
        <!-- <div class="right-menu-badge">
          <el-badge :value="getUserInfo.no_read_num" class="item">
            <img class="msg" src="@/assets/image/msg.png" alt="">
          </el-badge>
        </div> -->

        <el-dropdown
          v-if="getUserInfo.nickname"
          class="avatar-container right-menu-item hover-effect"
          trigger="click"
        >
          <div class="avatar-wrapper">
            <img :src="getUserInfo.avatar" class="user-avatar" />
            <div>{{ getUserInfo.nickname }}</div>
            <i class="el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item disabled>
              {{ getUserInfo.nickname }}
            </el-dropdown-item>
            <router-link class="inlineBlock" to="/info">
              <el-dropdown-item divided> 修改个人信息 </el-dropdown-item>
            </router-link>
            <el-dropdown-item>
              <span style="display: block" @click="logout">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="no-login-box" @click="goLogin" v-else>
          <img class="no-login" src="@/assets/image/no_login.png" />
          <div>未登录，请先登录</div>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import Cookies from "js-cookie";
import request from "@/utils/request";
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "username", "getUserInfo"]),
  },
  data() {
    return {
      visible: false,
      notifyLogList: [],
      loading: true,
    };
  },
  created() {
    if (localStorage.getItem("userInfo")) {
      this.$store.commit(
        "setUserInfo",
        JSON.parse(localStorage.getItem("userInfo"))
      );
      this.info();
      setInterval(() => {
        this.info();
      }, 10 * 1000);
    }
  },
  watch: {
    visible(val) {
      this.notifyLogList = [];
      if (val) {
        this.notifyLog();
      }
    },
  },
  methods: {
    // gopay(){
    //   this.$router.push('/pay')
    // },
    goMore() {
      this.$router.push("/forum/notifyLog");
      this.visible = false;
    },
    info() {
      return request({
        url: "/api/userend/user/info",
        method: "get",
        params: {},
      }).then((response) => {
        this.infos = response.data;
        localStorage.setItem("userInfo", JSON.stringify(response.data));
        this.$store.commit(
          "setUserInfo",
          JSON.parse(localStorage.getItem("userInfo"))
        );
      });
    },
    notifyLog() {
      this.loading = true;
      return request({
        url: "/api/userend/user/notifyLog",
        method: "get",
        params: {},
      }).then((response) => {
        this.loading = false;
        let arr = [];
        arr = response.data.data;
        for (var i = 0; i < arr.length; i++) {
          if (i <= 3) {
            this.notifyLogList.push(arr[i]);
          }
        }
        this.info();
      });
    },
    // toggleSideBar() {
    //   this.$store.dispatch("ToggleSideBar");
    // },
    goLogin() {
      this.$emit("goLogin", true);
    },
    logout() {
      this.$store.dispatch("FedLogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
  },
};
</script>

<style lang="scss">
.el-popover {
  border-radius: 15px;
}
.msg {
  padding: 20px 10px 0 10px;
  border: chartreuse;
  .more {
    cursor: pointer;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    p {
      margin-left: 5px;
    }
  }
  .msg-box {
    padding: 15px 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #f9fafd;
    img {
      width: 40px;
      height: 40px;
    }
    .msg-box-content {
      margin-left: 15px;
      div {
        &:nth-child(1) {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1e2134;
        }
        &:nth-child(2) {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin: 10px 0;
        }
        &:nth-child(3) {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #858585;
        }
      }
    }
  }
}
.right-menu-badge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.item {
  // margin-top: 10px;
  margin-right: 10px;
  margin-top: 10px;
}
.el-badge {
  margin-right: 30px;
}
.no-login-box {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-right: 30px;
  .no-login {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin-right: 10px;
  }
}
.navbar {
  width: 100%;
  height: 80px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .navbar-box {
    margin-left: 7px;
    padding: 5px 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    left: 0;
    img {
      width: 151px;
      height: 80px;
    }
  }

  .hamburger-container {
    line-height: 50px;
    height: 50px;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .right-menu {
    height: 50px;
    // line-height: 50px;
    position: absolute;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    &:focus {
      outline: none;
    }

    .msg {
      width: 30px;
      height: 30px;
    }
    .right-menu-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        // margin-top: 5px;
        // position: relative;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        div {
          margin-left: 10px;
        }
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          margin-left: 8px;
          // position: absolute;
          // right: -20px;
          // top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

.hasTagsView {
  .navbar {
    box-shadow: none;
  }
}
</style>
